import { Period, periodTypesMap } from '@geovelo-frontends/commons';

export function getPeriodTitle(period: Period | null): string {
  if (!period) return '';

  const { alternativeTitleKey, titleKey } = periodTypesMap[period.type];
  return alternativeTitleKey || titleKey;
}
